import TopicPageTemplate from '@templates/topic-page/detail';

// ---------------------------------------------------------

import { getTopicLandingProps } from '@lib/topic-landing-props';

// ---------------------------------------------------------

export async function getStaticProps(context) {
  return getTopicLandingProps('HomeServices', context);
}

// ---------------------------------------------------------

const Home = ({ pageData, preview }) => {
  return (
    <TopicPageTemplate
      collection="HomeServices"
      coreService
      pageData={pageData}
      preview={preview}
    ></TopicPageTemplate>
  );
};

export default Home;
